import React from 'react';
import TabbedPage from '../../../Elements/TabbedPage';

function TabContent({ text }) {
  return <div style={{ padding: 16, fontSize: 13.5 }}>{text}</div>;
}

function TabbedPageDemoComponent() {
  return (
    <TabbedPage
      removeSearchParametersOnTabChange={false}
      onTabChange={() => {}}
      tabs={[
        {
          label: 'Information',
          icon: 'fa-solid fa-info',
          component: <TabContent text='General information tab content (dummy).' />,
        },
        {
          label: 'Payments',
          icon: 'fa-solid fa-money-bill-wave',
          component: <TabContent text='Payments tab content (dummy).' />,
        },
        {
          label: 'Comments',
          icon: 'fa-regular fa-comments',
          component: <TabContent text='Comments tab content (dummy).' />,
        },
      ]}
    />
  );
}

export const tabbedPageDemo = {
  id: 'tabbed-page',
  title: 'TabbedPage',
  category: 'Navigation & Layout',
  importPath: 'Elements/TabbedPage',
  notes: [
    'Tab object: { label, icon, component, roleKey? } — roleKey hides the tab unless RoleService grants it (roleKey of empty string or omitted = always visible).',
    'openOnTab sets the initial tab; onTabChange reports switches; refreshTabOnChange (default true) remounts tab content on change via a key swap.',
    'MUI scrollable tabs hide scroll arrows below the sm breakpoint — TabbedPage already sets allowScrollButtonsMobile.',
    'removeSearchParametersOnTabChange (default false) is the ONLY URL side effect: when true, switching tabs strips ALL query params from the URL — that would clobber this gallery’s ?entry= param. Nothing like ?tab= is ever written; tab state lives in component state only.',
    'With a single tab the tab strip is hidden entirely — only the content renders.',
  ],
  snippet:
    "<TabbedPage\n  tabs={[\n    { label: 'Information', icon: 'fa-solid fa-info', component: <InfoTab /> },\n    { label: 'Comments', icon: 'fa-regular fa-comments', component: <Comments entityTypeId={38} entityId={id} /> },\n  ]}\n/>",
  render: TabbedPageDemoComponent,
};
